__turbopack_context__.v({
  "buttonsWrapper": "kWHjIG_buttonsWrapper",
  "wrapper": "kWHjIG_wrapper",
});
